<template>
  <div class="">
    <v-edit-dialog
      large
      :return-value.sync="item.ikomClient"
      @open="OnDialogOpen(item)"
      save-text="Записать"
      cancel-text="Отмена"
    >
      <div>
        {{ String(addCommas(item.ikomClient)).replace(",00", "") }}
        <v-icon right small>edit</v-icon>
      </div>
      <template v-slot:input>
        <div class="mt-4 title">Обновить Комиссию</div>
      </template>
      <template v-slot:input>
        <v-text-field
          v-model="item.ikomClient"
          @focus="OnTextFielsFocus($event)"
          label="Править"
          v-mask="'############'"
          single-line
        ></v-text-field>
      </template>
      <span class="procent" v-if="procentShow">{{
        procent(item.ikomClient, calc.summ, calc.days, yearProcent)
      }}</span>
    </v-edit-dialog>
  </div>
</template>
<script>
export default {
  name: "",
  data: () => ({}),
  props: {
    item: { type: Object },
    calc: { type: Object },
    yearProcent: { type: Boolean },
    procentShow: { type: Boolean, default: true },
  },
  methods: {
    OnDialogOpen(item) {
      item.ikomClient = item.ikomsk;
    },
  },
};
</script>
<style lang="sass" scoped></style>
